<!--
 * @Description: 登录
 * @Date: 2024-11-18 11:22:23
-->

<template>
  <div class="user-login">
    <base-svg :iconClass="`logo`" className="user-login__logo"></base-svg>
    <div class="user-login__right">
      <p
        class="user-login__title"
        :style="{
          textAlign: componentName === 'login-success' ? 'center' : 'left'
        }"
      >
        {{ title }}
      </p>
      <component v-model="componentName" :is="currentComponent"></component>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { ref, computed } from 'vue';

import { APP_NAME } from '../constants/index';

import { BaseSvg } from '@/components/base/base-svg';
import LoginRegister from '../components/login-register.vue';
import LoginSetpwd from '../components/login-setpwd.vue';
import LoginMain from '../components/login-main.vue';
import LoginForget from '../components/login-forget.vue';
import LoginReset from '../components/login-reset.vue';
import LoginSuccess from '../components/login-success.vue';

const COMPONENT_MAPPING = {
  // 右侧 注册
  'login-register': LoginRegister,
  // 右侧 注册-设置登录密码
  'login-setpwd': LoginSetpwd,
  // 右侧 登录
  'login-main': LoginMain,
  // 忘记密码  先验证手机号
  'login-forget': LoginForget,
  // 忘记密码  重置密码
  'login-reset': LoginReset,
  // 重置成功
  'login-success': LoginSuccess
  // [LoginSuccess.__name]: LoginSuccess  类型无法识别
};

const componentName = ref<keyof typeof COMPONENT_MAPPING>('login-main');

const currentComponent = computed(() => {
  return COMPONENT_MAPPING[componentName.value];
});
const title = computed(() => {
  return componentName.value === 'login-success' ? '重置密码成功' : APP_NAME;
});
</script>

<style lang="scss">
@import '../styles/index.scss';
</style>
